import type { ReactElement } from 'react';
import type { TranslationState } from '@contracts/common';
import { languageName } from '../lib/written-in';

/**
 * "Translated from Russian · Show original" (PRD 57).
 *
 * ⚠ Said wherever a translation is shown, so nobody mistakes it for what was
 * said — and one press away from the original, which is the record. When a
 * part is still being translated it says so, because a page half in one
 * language and half in another otherwise reads as a bug.
 */
export function Translated({
  state,
  onToggle,
}: {
  state: TranslationState | null;
  onToggle: () => void;
}): ReactElement | null {
  if (!state) return null;
  const from = state.from.map(languageName).join(' and ');
  const to = languageName(state.to);
  const toggle = (label: string) => (
    <button type="button" className="linkish mono" onClick={onToggle}>
      {label}
    </button>
  );
  return (
    <p className="mono translated" role="status">
      {state.original ? (
        <>
          The original{from ? `, in ${from}` : ''} · {toggle(`Show in ${to}`)}
        </>
      ) : state.pending ? (
        <>
          Translating into {to}… what is not ready yet shows as it was written ·{' '}
          {toggle('Show original')}
        </>
      ) : (
        <>
          Translated{from ? ` from ${from}` : ''} · {toggle('Show original')}
        </>
      )}
    </p>
  );
}
